export default "__VITE_ASSET__CME01XFN__"